import apiClient from './client';

export const authServices = {
  login: async (formData) => {
    const response = await apiClient.post('/student/login', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },
};
